export default __webpack_public_path__ + "static/media/602e99e6b4e073e4.4cc0f8ece8ddacdc0744d335718b6c0c.svg";